import { type AppLocale } from 'app-shared/types';

import { LOCALE_STORAGE_KEY } from '@/localization/constants/LocaleStorageKey';
import { detectInitialLocale } from '@/localization/utils/detectInitialLocale';

export const detectInitialLocaleFromBrowser = (): AppLocale =>
  detectInitialLocale({
    urlLocale: new URLSearchParams(window.location.search).get('locale'),
    storedLocale: localStorage.getItem(LOCALE_STORAGE_KEY),
    browserLanguages: navigator.languages,
  });
